import { useMemo } from "react";

import {
  PATH_SHADOW_GRADIENT_ID,
  PathShadow,
} from "@components/PerformanceChart/MainPath/PathShadow";
import { usePerformanceChart, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { buildLinearChart } from "@utils";
import { nodes } from "./content";

const OPACITY = 0.12;

export const EmptyPath = () => {
  const { theme } = useTheme();

  const { strokeWidth, width } = usePerformanceChart();

  const data = useMemo(() => {
    return buildLinearChart({
      data: nodes,
      label: i18n.t(Translations.PerformanceChartOneDayLabel),
      width,
    });
  }, [nodes, width]);

  const { path, pathShadow } = data;

  const strokeColor = theme.chart.performance.stroke;

  if (!path || !pathShadow) return null;

  return (
    <>
      <path
        d={path}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
        strokeOpacity={OPACITY}
      />

      <path
        d={pathShadow}
        stroke="none"
        fill={`url(#${PATH_SHADOW_GRADIENT_ID})`}
        fillOpacity={OPACITY}
      />

      <PathShadow />
    </>
  );
};
